import styled from "styled-components";
import { Paper, TextField, Button, TextareaAutosize } from "@mui/material";

export const InspectionItemContainer = styled.div`
  background-color: #f6f6f6;
  margin: 15px 0;
  padding: 10px;
  border: 1px #CCC solid;
`;

export const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
`

export const SubQuestionWrapper = styled.div`
  margin: 10px 25px;
  flex-direction: row;
  flex: 1;
`;

export const StyledTextField = styled(TextField)`
  margin: 10px 0 !important;
`;
